import type {SharedRouteInfoResponse} from 'src/api/types'

import type {WebDeliveryState} from '../types/webState'

export function webStateToSharedRoute(state: WebDeliveryState): SharedRouteInfoResponse {
  const {
    context,
    sorted_route_points,
    primary_actions,
    secondary_actions,
    summary,
    description,
    performer,
    performer_route,
    icon_strategy,
    content_sections,
    timeline,
    postcard,
    paid_waiting_info,
    cost_details,
    poll,
    accent_state_button,
    bottom_content_sections,
  } = state

  return {
    context: {
      is_performer_position_available: context.is_performer_position_available,
      performer_search: Boolean(context.performer_search?.is_in_progress),
      provider_status: context.provider_status,
      provider_tariff_class: context.provider_tariff_class,
    },
    summary,
    description,
    route_points: sorted_route_points,
    actions: [...primary_actions, ...secondary_actions],
    performer,
    performer_route,
    icon_strategy,
    content_sections,
    timeline,
    postcard,
    paid_waiting_info,
    cost_details,
    poll,
    accent_state_button,
    bottom_content_sections,
  }
}
